import { get, post } from '@elementary/common-ui/utils/http';
import { EnvironmentConnectionHealth } from 'shared/types/connectionHealth';

export const fetchConnectionHealth = (
  envId: string,
): Promise<EnvironmentConnectionHealth> =>
  get(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/connection-health`,
  );

export const revalidateConnectionHealth = (
  envId: string,
): Promise<EnvironmentConnectionHealth> =>
  post(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/connection-health/revalidate`,
  );
